import React from 'react';
import ContentLoader from 'react-content-loader';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';

const styles = ({ spacing: { unit }, palette: { text } }: Theme) =>
  createStyles({
    root: {
      width: '100%',
      padding: unit * 3,
    },
    title: {
      color: text.primary,
      fontWeight: 600,
      fontSize: 18,
      padding: 0,
      display: 'inline-block',
      marginBottom: unit * 10,
    },
  });

export interface ContentLoaderReportsProps extends WithStyles<typeof styles> {}

const ContentLoaderReports: React.FC<ContentLoaderReportsProps> = ({ classes, ...rest }) => (
  <div className={classes.root} {...rest}>
    <div className={classes.title}>Upload Referrals</div>
    <ContentLoader width={800} height={800}>
      <rect x="0" y="0" rx="3" ry="3" width="334" height="30" />
      <rect x="0" y="70" rx="3" ry="3" width="936" height="30" />
    </ContentLoader>
  </div>
);

export default withStyles(styles)(ContentLoaderReports);
